import { StyledError, StyledErrorWrapper } from './error.styles'
import { WarningIcon } from 'primsell-shared-layer/assets/icons'

interface IErrorProps {
  error?: string
}

const Error = ({ error }: IErrorProps): JSX.Element => {
  return (
    <StyledErrorWrapper>
      <WarningIcon />
      <StyledError variant="h5">{error}</StyledError>
    </StyledErrorWrapper>
  )
}

export { Error }
